var Popup, Marker; // Classes

var SharplaunchMap = {
    map: null,
    markers: [],
    bounds: null,
    map_center: null,
    active_marker: null,
    active_categories: ['0'],
    cat_colors: {},
    last_zIndex:10000,
    styles: bootstrap.map.styles || null,
    marker_path: 'M7.536,5.064c0,1.398-1.139,2.532-2.544,2.532c-1.405,0-2.544-1.134-2.544-2.532c0-1.398,1.139-2.532,2.544-2.532C6.397,2.532,7.536,3.666,7.536,5.064M10.176,5.064C10.176,2.267,7.897,0,5.088,0C2.278,0,0,2.267,0,5.064c0,1.23,0.441,2.357,1.173,3.234l3.919,5.628l3.976-5.71C9.211,8.039,9.342,7.852,9.46,7.654L9.5,7.597H9.493C9.927,6.852,10.176,5.987,10.176,5.064',
    loadScript: function() {

        var mapsapi = document.createElement("script");
        mapsapi.type = "text/javascript";
        mapsapi.src = "https://maps.google.com/maps/api/js?key=AIzaSyC5z50VGadxviwn6IlNfY0eKT7IUu22ffI&loading=async&libraries=marker&callback=SharplaunchMap.init";
        document.body.appendChild(mapsapi);

    },
    init: function() {

        var self = this;
        let mapCanvas = document.getElementById('map_canvas');
        self.map_center = new google.maps.LatLng(mapCanvas.getAttribute('data-latitude'), mapCanvas.getAttribute('data-longitude'));
        this.bounds = new google.maps.LatLngBounds();
        this.map = new google.maps.Map(document.getElementById('map_canvas'), {
            zoom: parseInt(mapCanvas.dataset.zoom),
            center: self.map_center,
            mapTypeControl: false,
            scrollwheel: false,
            scaleControl: false,
            streetViewControl: false,
            zoomControl: false,
            panControl: false,
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapId: "1dfc966b10cac119",
        });

        // Map category colors
        bootstrap.poi_cats.forEach((v,k) => {
            self.cat_colors[v.id] = v.color;
        });


        /* Popup Class */
        Popup = function(index, data, position, content) {
            this.position = position;
            this.index = index;
            this.poi = data;
            this.type = 'logo';
            this.offset = {x:0 ,y:0 };
            this.content = content;
            this.content.classList.add('popup-bubble-content');
            var pixelOffset = document.createElement('div');
            pixelOffset.classList.add('popup-bubble-anchor');
            pixelOffset.appendChild(content);
            this.anchor = document.createElement('div');
            this.anchor.classList.add('popup-tip-anchor');
            this.anchor.appendChild(pixelOffset);
            this.stopEventPropagation();
            this.setMap(self.map);
            this.visible = true;
        };

        Popup.prototype = Object.create(google.maps.OverlayView.prototype);

        Popup.prototype.onAdd = function() {
            this.getPanes().floatPane.appendChild(this.anchor);
            var self = this;
            this.anchor.addEventListener('click',function(e){
                self.showTooltip()
            });
        };

        Popup.prototype.isVisible =  function(){ return this.visible; }

        Popup.prototype.getPosition =  function(){ return this.position; }

        Popup.prototype.hideTooltip = function(){
            this.content.classList.add("shadow");
            let mapTooltip = document.getElementById('map-tooltip');
            mapTooltip.classList.remove("regular", "logo");
            mapTooltip.classList.add("hide");
        }

        Popup.prototype.showTooltip = function() {
            if (this.poi.category === "" && this.poi.name === "") return;
            
            var that = this;
            self.closeAllTooltips();
            self.active_marker = this.index;
            this.hide();
            self.last_zIndex++;
            this.anchor.style.zIndex = self.last_zIndex;

            var html = '<div class="tooltip-content"><h3>'+this.poi.name+'</h3><span>'+this.poi.address+'</span></div>';
            
            var logo_html = "";
            if (this.poi.logo_url) {
                logo_html = '<img width="100" src="'+this.poi.logo_url+'">';
            }

            html = '<i class="icon close icon-close" style="display:none;cursor:pointer;position:absolute;right:4px;top:3px;color:#ddd;"></i>'
                    + logo_html 
                    + html;

            this.tooltipPosition();

            var mapTooltip = document.querySelector('#map-tooltip');
            mapTooltip.classList.remove('regular');
            mapTooltip.classList.add('logo');
            mapTooltip.innerHTML = html;
            mapTooltip.style.width = '73px';
            mapTooltip.style.height = '73px';
            mapTooltip.classList.remove('hide');
            mapTooltip.style.padding = '0';
            mapTooltip.style.maxHeight = '0';
            mapTooltip.style.overflow = 'hidden';

            var closeIcon = mapTooltip.querySelector('.icon-close');
            closeIcon.style.display = 'none';

            var animation = mapTooltip.animate([
                {width: '73px', height: '73px', padding: '10px'},
                {width: '335px', height: 'inherit', padding: '10px'}
            ], { duration: 250 });

            animation.onfinish = function() {
                closeIcon.style.display = 'block';
                mapTooltip.style.width = '335px';
                mapTooltip.style.padding = '10px';
                closeIcon.addEventListener('click', function() {
                self.closeAllTooltips();
                });
            };
        };

        Popup.prototype.tooltipPosition = function(){
            var that = this;
            var pos = that.getProjection().fromLatLngToContainerPixel(that.position);
            var left = pos.x - 30;
            var top = pos.y - 63;
            // set position
            var tooltip = document.getElementById('map-tooltip');
            tooltip.style.left = left + 'px';
            tooltip.style.top = top + 'px';
            tooltip.style.display = "block";
        }

        Popup.prototype.draw = function() {
            var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
            this.offset = divPosition;
            // Hide the popup when it is far out of view.
            var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none';
            if (display === 'block') {
              this.anchor.style.left = parseInt(divPosition.x - 30) + 'px';
              this.anchor.style.top = parseInt(divPosition.y - 25) + 'px';
            }
            if (this.anchor.style.display !== display) {
              this.anchor.style.display = display;
            }

            if (this.poi.category == "0" || this.poi.category == ""){;
                this.content.style.setProperty('--accent-color', '#'+self.cat_colors[this.poi.category]);
            }else{
                // Experimental border-bottom  for logos
                this.content.style.borderBottom = "3px solid #" + self.cat_colors[this.poi.category];
            }

        };

        Popup.prototype.stopEventPropagation = function() {
            var anchor = this.anchor;
            anchor.style.cursor = 'auto';

            ['click','dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
            'pointerdown']
              .forEach(function(event) {
                anchor.addEventListener(event, function(e) {
                  e.stopPropagation();
                });
            });
        };

        Popup.prototype.show = function(){
            this.content.style.display = 'block';
            this.visible = true;
        }

        Popup.prototype.hide = function(){
            this.content.style.display = 'none';
            this.visible = false;
            this.hideTooltip();
        }

        /* Marker Class */
        Marker = function(index, data) {
            var that = this;
            this.index = index;
            this.visible = true;
            this.position = new google.maps.LatLng(data.lat, data.lng);
            this.map = SharplaunchMap.map;
            this.zIndex = 9999;
            this.poi = data;

            let needs_tooltip = Object.keys(data).length > 2;
            
            const markerContent = document.createElement('div');
            markerContent.style.width = '20px';
            markerContent.style.height = '20px';
            markerContent.style.borderRadius = '50%';
            const categoryColor = SharplaunchMap.cat_colors[data.category] || '#FF0000';
            markerContent.style.backgroundColor = `#${categoryColor}`;
            
            this.content = markerContent;
            
            const advancedMarkerOptions = {
                map: this.map,
                position: this.position,
                zIndex: this.zIndex,
            };

            if (this.poi.name) advancedMarkerOptions.title = this.poi.name;
            if (needs_tooltip) advancedMarkerOptions.content = markerContent;
            
            this.marker = new google.maps.marker.AdvancedMarkerElement(advancedMarkerOptions);
            
            // Create an OverlayView
            this.overlay = new google.maps.OverlayView();
            this.overlay.onAdd = function() {};
            this.overlay.draw = function() {};
            this.overlay.setMap(this.map);
            
            // Attach click listener only if more data properties exist beyond lat and lng
            if (Object.keys(data).length > 2) {
                this.marker.addListener('click', function() {
                    that.showTooltip();
                });
            }
            
            SharplaunchMap.bounds.extend(this.position);
        };

        Marker.prototype.isVisible =  function(){ return this.visible; }

        Marker.prototype.showTooltip = function(){
            SharplaunchMap.closeAllTooltips();
            SharplaunchMap.active_marker = this.index;
            if (this.poi.name || this.poi.address) {
                var html = '<i class="icon close icon-close" style="cursor:pointer;position:absolute;right: 4px;    top: 3px;    color: #ddd;"></i><div class="tooltip-content"><h3>'+this.poi.name+'</h3><span>'+this.poi.address+'</span></div>';
                var mapTooltip = document.querySelector('#map-tooltip');
                mapTooltip.classList.remove('logo');
                mapTooltip.classList.add('regular');
                mapTooltip.innerHTML = html;
                mapTooltip.classList.remove('hide');
                if (this.poi.category == "0" || this.poi.category == "") {
                    mapTooltip.classList.add('building');
                }
                var overlay = this.overlay;
                var proj = overlay.getProjection();
                var pos = proj.fromLatLngToContainerPixel(this.getPosition());
                var left = pos.x - 20;
                var top = pos.y + 22;
                mapTooltip.style.left = left + 'px';
                mapTooltip.style.top = top + 'px';
                var iconClose = mapTooltip.querySelector('.icon-close');
                iconClose.addEventListener('click', function() {
                    SharplaunchMap.closeAllTooltips();
                });
            }            
        }
        Marker.prototype.tooltipPosition = function(){
            var overlay = this.overlay;
            var proj = overlay.getProjection();
            var pos = proj.fromLatLngToContainerPixel(this.getPosition());
            var left = pos.x - 20;
            var top = pos.y + 22;

            var mapTooltip = document.querySelector('#map-tooltip');
            mapTooltip.style.left = left + 'px';
            mapTooltip.style.top = top + 'px';
        }
        Marker.prototype.show = function(){
            this.marker.setMap(SharplaunchMap.map);
            this.visible = true;
        }

        Marker.prototype.hide = function(){
            this.marker.setMap(null);
            this.visible = false;
            this.hideTooltip();
        }

        Marker.prototype.hideTooltip = function(){
            var mapTooltip = document.querySelector('#map-tooltip');
            mapTooltip.classList.remove('regular');
            mapTooltip.classList.remove('logo');
            mapTooltip.classList.add('hide');
        };

        Marker.prototype.getPosition = function() {
            return this.position;
        }

        /****************** END classes definitions ************************/


        // var main_marker = null;
        var main_markers = [];
        if (bootstrap.poi.length) {
            bootstrap.poi.forEach(function(v,k) {
                if (v.category == "0" || v.category == "") {
                    main_markers.push(v);
                    // main_marker = v;
                    // self.placeMainMarker(v);
                } else {
                    self.placeMarker(v);
                }
            });

        } else {
            self.placeMarker({
                lat: parseFloat(document.querySelector('#map_canvas').getAttribute('data-latitude')),
                lng: parseFloat(document.querySelector('#map_canvas').getAttribute('data-longitude'))
            });
        }
        
        // Render Building marker last, so it's on Z top
        // if (main_marker) self.placeMainMarker(main_marker);
        if (main_markers.length) {
            main_markers.forEach(function(building_marker,k) {
                self.placeMainMarker(building_marker);
            });
        } 

        if (bootstrap.poi_cats.length) {
            bootstrap.poi_cats.forEach(function(v,k) {
                if (v.id != '0') {
                    self.active_categories.push(v.id);
                }
            });
        }

        google.maps.event.addListener(this.map,'click',function(e) {
            self.closeAllTooltips();
        });

        google.maps.event.addListener(this.map,'zoom_changed',function() {
           self.closeAllTooltips();
        });

        google.maps.event.addListener(this.map,'center_changed',function() {
           // self.closeAllTooltips();
                self.tooltipPosition();
        });

        // enable controls
        this.mapControls();
    },
    tooltipPosition: function (){
        var self = this;
        if (self.active_marker != null){
            self.markers[self.active_marker].tooltipPosition();
        }
    },
    placeMarker: function(data) {
        var self = this;
        var location = new google.maps.LatLng(data.lat, data.lng);
        var index = self.markers.length;

        if (data.logo_url && data.logo_url !== "" && bootstrap.map.show_logos_directly && data.category !== "0") {
        var html = '<div id="randombubblemarker-' + index + '" class="shadow marker-bubble"><img width="50" src="' + data.logo_url + '"></div>';
        document.body.insertAdjacentHTML('beforeend', html);
        let popup = new Popup(index, data, location, document.getElementById('randombubblemarker-' + index));
        this.markers.push(popup);
        } else {
        let marker = new Marker(index, data);
        this.markers.push(marker);
        }

    },
    // Merge this back to placeMarker with an IF statement
    placeMainMarker: function(data) {
        var self = this;
        var location = new google.maps.LatLng(data.lat,data.lng)
        var index = self.markers.length;

        data.is_property = true;

        var marker_content = data.name;

        // lower fontsize if text is too long and/or cut it
        if (marker_content.length > 23){
            marker_content = '<span style="font-size:12px">' + marker_content.substr(0, 35) + '</span>';
        }

        if (data.logo_url){
            marker_content = '<img width="50" src="'+data.logo_url+'">';
        }

        var html  = '<div id="randombubblemarker-'+index+'" class="shadow marker-bubble is-property bg-accent">' + marker_content + '</div>';

        // Change marker for MM 123
        if (window.bootstrap.client_id == 123) {
            html = '<div id="randombubblemarker-' + index + '" class="is-svg-custom"><img width="40" height="50" src="/img/v2/clients/mm/map-marker.svg"></div>';
        }

        document.querySelector('body').insertAdjacentHTML('beforeend', html);
        popup = new Popup(index, data,
        location,
        document.getElementById('randombubblemarker-'+index));
        this.markers.push(popup);

    },
    filterPoisByCategory: function() {
        var self = this;

        for (var i = 0; i < this.markers.length; i++) {
            if (self.active_categories.indexOf(self.markers[i].poi.category) === -1) {
              if (this.markers[i].poi.category !== 0 && this.markers[i].isVisible()) {
                this.markers[i].hide();
              }
            } else if (!this.markers[i].isVisible()) {
              this.markers[i].show();
            }
          }
    },
    closeAllTooltips: function(){
        let self = this;
        self.active_marker = null;
        let markerBubbles = document.querySelectorAll('.marker-bubble');
        markerBubbles.forEach(function(markerBubble) {
            markerBubble.classList.add('shadow');
        });
        for (let i = 0; i < this.markers.length; i++ ) {
            if (!this.markers[i].isVisible() && (self.active_categories.indexOf(this.markers[i].poi.category) > -1 || this.markers[i].poi.category == "") )
            this.markers[i].show();
        }
        let mapTooltip = document.querySelector('#map-tooltip');
        mapTooltip.classList.remove('building', 'regular', 'logo');
        mapTooltip.classList.add('hide');

    },
    mapControls: function() {
        var self = this;

        // self.map.fitBounds(self.bounds);

        let mapCategories = document.querySelectorAll('#map-categories li');
        mapCategories.forEach(function(category) {
            category.addEventListener('click', function(e) {
                if (!category.classList.contains('active')) {
                    category.classList.add('active');
                    // add to active categories
                    self.active_categories.push(category.dataset.id);
                } else {
                    category.classList.remove('active');

                    // get index of class to be removed
                    let index = self.active_categories.indexOf(category.dataset.id);
                    if (index > -1) {
                        self.active_categories.splice(index, 1);
                    }
                }
                self.filterPoisByCategory();
            });
        });

        // init zoom control
        // if($('#zoom-slider').length) {
        //     var zoom_slider = $('#zoom-slider').slider({
        //         min: 10,
        //         max: 20,
        //         step: 1,
        //         range: 'min',
        //         value: $('#map_canvas').data('zoom'),
        //         slide: function(event, ui) {
        //             self.map.setZoom(ui.value);
        //         }
        //     });
        // }

        var zoomInButton = document.querySelector('.zoom-control .zoom-in');
        if (zoomInButton) zoomInButton.addEventListener('click', function(){
            var value;
            if(typeof zoom_slider !== 'undefined') {
                value = document.querySelector('#zoom-slider').slider('value') + 1;
                // $('#zoom-slider').slider('value', value);
            } else {
                value = self.map.getZoom() + 1;
            }
            self.map.setZoom(value);
        });

        var zoomOutButton = document.querySelector('.zoom-control .zoom-out');
        if (zoomOutButton) zoomOutButton.addEventListener('click', function(){
            var value;
            if(typeof zoom_slider !== 'undefined') {
                value = document.querySelector('#zoom-slider').slider('value') - 1;
                // $('#zoom-slider').slider('value', value);
            } else {
                value = self.map.getZoom() - 1;
            }
            self.map.setZoom(value);
        });

        var mapTypeButton = document.querySelector('.map-type');
        if (mapTypeButton) mapTypeButton.addEventListener('click', function(){
            if (this.classList.contains("open")) {
                this.classList.remove("open");
            } else {
                this.classList.add("open");
            }
        });

        var mapTypeList = document.querySelectorAll('.map-type ul li');
        if (mapTypeList) {
            mapTypeList.forEach(function(item) {
                item.addEventListener('click', function(e) {
                    e.preventDefault();
                    var type = this.querySelector('a').getAttribute('map-type');
                    switch (type) {
                        case 'terrain':
                            type = google.maps.MapTypeId.TERRAIN;
                            break;
                        case 'default':
                            type = google.maps.MapTypeId.ROADMAP;
                            break;
                        case 'satellite':
                            type = google.maps.MapTypeId.SATELLITE;
                            break;
                    }
                    self.map.setMapTypeId(type);
                });
            });
        }        

        var enterFullScreenButton = document.getElementById("enter-full-screen");
        if (enterFullScreenButton) enterFullScreenButton.addEventListener("click", function (e) {
            e.preventDefault();
            if (document.body.classList.contains("map-full-screen")) {
                self.closeFullScreen();
                var zoomButtons = document.querySelectorAll(
                    ".zoom-control .button"
                );
                for (var i = 0; i < zoomButtons.length; i++) {
                    zoomButtons[i].classList.remove("active");
                }
            } else {
                document
                    .querySelector(".zoom-control #enter-full-screen")
                    .classList.add("active");
                self.openFullScreen();
            }
        });

        var exitFullScreenButton = document.getElementById("exit-full-screen");
        if (exitFullScreenButton) exitFullScreenButton.addEventListener("click", function (e) {
            e.preventDefault();
            self.closeFullScreen();
        });  

        var centerInButton = document.querySelector(".zoom-control .center-in");
        if (centerInButton) centerInButton.addEventListener("click", function () {
            self.map.setCenter(map_center);
            self.map.setZoom(12);
            document.querySelector("#zoom-slider").slider("value", 15);
        });

        var legendButton = document.querySelector(".zoom-control .button.legend");
        if (legendButton) legendButton.addEventListener("click", function () {
            if (!this.classList.contains("active")) {
                this.textContent = "Hide Legend";
                this.classList.add("active");
                document
                    .querySelector("#map-categories")
                    .classList.add("active");
            } else {
                this.textContent = "View Legend";
                this.classList.remove("active");
                document
                    .querySelector("#map-categories")
                    .classList.remove("active");
            }
        });

        // set position
        /*
        $('.zoom-control').css({
            top: $('#location .section-title').position().top+$('#location .section-title').outerHeight()
        });
        */
       var locationTitle = document.querySelector('#location .section-title');
       if (locationTitle) this.map.panBy(0, -Math.floor(locationTitle.offsetHeight / 2));

    },
    openFullScreen: function(){
        document.querySelector("#map_canvas").classList.add("fullscreen");
        document.querySelector('body').classList.add("map-full-screen");
        document.querySelector('#map-tooltip').style.position = "fixed";
        setTimeout(function(){
        google.maps.event.trigger(self.map, 'resize');
        },500);

        return false;
    },
    closeFullScreen: function(){
        document.querySelector('body').classList.remove('map-full-screen');
        document.querySelector('#map_canvas').classList.remove('fullscreen');
        document.querySelector('#map-tooltip').style.position = 'absolute';

        return false;
    }

}

document.addEventListener("DOMContentLoaded", (event) => {
    var mapCanvas = document.querySelector('#map_canvas');
    if (mapCanvas) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    console.log('Loading google maps right now');
                    SharplaunchMap.loadScript();
                    observer.unobserve(entry.target);
                }
            });
        });

        const lazyLoadMapElements = document.querySelectorAll("#map_canvas");
        lazyLoadMapElements.forEach((element) => {
            observer.observe(element);
        });
    }
});

// Make it accessible on the global scope.
window.SharplaunchMap = SharplaunchMap;